/*
 * @license
 * @desc: 渐变图例
 * Copyright (c) 2019, the Gago Inc All rights reserved.
 * @author: ZQ.xia (xiazhiqiang@gagogroup.com)
 * @created: 2019/1/17 2:29 PM
 */
// tslint:disable:jsx-no-lambda
import * as React from "react";
import styled from "styled-components";
import { uniqueId } from "lodash/fp";
import { BasicLegend, themeTypes } from "../basic-legend";
// tslint:disable-next-line: variable-name
const Root = styled(BasicLegend) `

  .list {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex: 1 1;
    > .colorWrap {
      margin: auto;
      .listWrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        & > div {
          flex: 1 1;
          display: flex;
          align-items: center;
        }
      }
    }

    .item {
      padding: 0 12px 0 20px;
      cursor: pointer;
      &:hover {
        background-color: ${p => p.colorPalette.blackColor[1]};
      }
    }
  }
`;
// tslint:disable: variable-name
const Color = styled.div `
  background: ${props => props.color};
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 4px;
  margin-left: 12px;
`;
/**
 * 渐变图层，分级连续图例
 *
 * @author ZQ.Xia
 * @date 2019-01-29
 * @export
 * @class GradientLegend1
 * @extends {(React.PureComponent<GradientLegendProps & ICSSProps & ColorProps<GlobalColorPalette>>)}
 * @implements {ICSS}
 * @implements {Color<GlobalColorPalette>}
 * @example
 * <GradientLayer
 *  value="daban"
 *  id="GradientLayer"
 *  url="http://139.219.239.1/hebei_shijiazhuang/daban.lerc"
 *  coordinates={[
 *    [113.5187, 38.7626],
 *    [115.4745, 38.7626],
 *    [115.4745, 37.4342],
 *    [113.5187, 37.43]
 *  ]}
 *  sourceMaxzoom={14}
 *  sourceMinzoom={9}
 *  valueMax={7}
 *  valueMin={1}
 *  colors={[
 *    "rgba(241,208,110,0.6)",
 *    "rgba(241,208,110,0.6)",
 *    "rgba(200,120,60,0.6)",
 *    "rgba(153,77,20,0.6)",
 *    "rgba(153,77,20,0.6)"
 *  ]}
 *  positions={[1, 3, 3.5, 4, 7]}
 *  colorscaleType="exponential"
 * >
 *  {(props: any) => (
 *    <GradientLegend1
 *      {...props}
 *      style={{
 *        position: "absolute",
 *        left: "100px",
 *        bottom: "215px"
 *      }}
 *      title="渐变图层"
 *      unit="斤"
 *      names={["低", "中等", "非常高"]}
 *      colorPalette={globalColorPalette}
 *    />
 *  )}
 * </GradientLayer>
 */
export class GradientLegend1 extends React.PureComponent {
    constructor() {
        super(...arguments);
        /**
         * 合并相邻的相同颜色的阶梯
         * 主要合并开头两个阶梯和最后两个阶梯
         * 包含下限，不包含上限
         *
         * @private
         * @memberof GradientIntervalLegend
         */
        this.mergeInterval = (colors) => {
            const result = [];
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < colors.length; i++) {
                if (result.length === 0) {
                    result.push(colors[i]);
                }
                else if (colors[i][1] !== result[result.length - 1][1]) {
                    result.push(colors[i]);
                }
            }
            return result;
        };
    }
    render() {
        const colors = this.props.colors;
        const min = colors[0][0];
        const max = colors[colors.length - 1][0];
        const mergedColors = this.mergeInterval(this.props.colors);
        const marks = {};
        mergedColors.forEach((item, index) => {
            // tslint:disable-next-line: no-empty
            if (index === 0) {
            }
            else if (index === mergedColors.length - 1) {
                // tslint:disable-next-line: no-collapsible-if
            }
            else {
                if (this.props.names[index]) {
                    marks[item[0]] = this.props.names[index];
                }
            }
        });
        const gradientLinerColor = graidentColor(mergedColors, min, max, "top");
        // tslint:disable: jsx-no-multiline-js
        return (React.createElement(Root, { theme: this.props.theme, style: this.props.style, className: this.props.className, colorPalette: this.props.colorPalette, title: this.props.title, unit: this.props.unit },
            React.createElement("div", { className: "colorWrap" },
                React.createElement("div", { className: "listWrap" }, mergedColors
                    .slice()
                    .reverse()
                    .map((item, index) => {
                    return (React.createElement("div", { className: "item", key: uniqueId("gradient-interval-legend") }, this.props.names.slice().reverse()[index]));
                })),
                React.createElement(Color, { color: gradientLinerColor }))));
    }
}
GradientLegend1.defaultProps = {
    theme: themeTypes[0],
};
function graidentColor(colors, min, max, direction = "top") {
    const length = colors.length;
    const colorsStr = colors.map((colorItem, index) => {
        const [, color] = colorItem;
        const precent = `${(1 / (length - 1)) * 100 * index}%`;
        return `${color} ${precent}`;
    });
    return `linear-gradient(to ${direction}, ${colorsStr.join()})`;
}
//# sourceMappingURL=index.js.map